import React from 'react';
import { motion } from 'framer-motion';
import { cn } from "@/lib/utils";

interface FeatureCardHorizontalProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  className?: string;
}

export const FeatureCardHorizontal = ({ icon, title, description, className }: FeatureCardHorizontalProps) => {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className={cn(
        "bg-card text-card-foreground p-6 rounded-lg border border-border flex items-start gap-4",
        "transition-all duration-300 ease-in-out",
        "hover:shadow-lg",
        className
      )}
    >
      {/* Icon container */}
      <div className="flex-shrink-0 bg-primary/10 p-3 rounded-full">
        {icon}
      </div>

      {/* Content */}
      <div className="flex-1">
        <h3 className="text-lg font-semibold mb-2 tracking-tight">
          {title}
        </h3>
        <p className="text-sm text-muted-foreground leading-relaxed">
          {description}
        </p>
      </div>
    </motion.div>
  );
};
